<template>
	<div class='pr-4'>
		<IconSvgBank
			:color="color"
			v-if="type === 'Bank'"
		/>
		<IconSvgBook
			:color="color"
			v-else-if="type === 'Book'"
		/>
		<IconSvgBookClosed
			:color="color"
			v-else-if="type === 'Book_closed'"
		/>
		<IconSvgBulb
			:color="color"
			v-else-if="type === 'Bulb'"
		/>
		<IconSvgCalculator
			:color="color"
			v-else-if="type === 'Calculator'"
		/>
		<IconSvgCategories
			:color="color"
			v-else-if="type === 'Categories'"
		/>
		<IconSvgBuy
			:color="color"
			v-else-if="type === 'Buy'"
		/>
		<IconSvgPin
			:color="color"
			v-else-if="type === 'Pin'"
		/>
		<IconSvgCertificat
			:color="color"
			v-else-if="type === 'Certificat'"
		/>
		<IconSvgChair
			:color="color"
			v-else-if="type === 'Chair'"
		/>
		<IconSvgClock
			:color="color"
			v-else-if="type === 'Clock'"
		/>
		<IconSvgCommunity
			:color="color"
			v-else-if="type === 'Community'"
		/>
		<IconSvgCompanyDirectory
			:color="color"
			v-else-if="type === 'Company_directory'"
		/>
		<IconSvgFolder
			:color="color"
			v-else-if="type === 'Folder'"
		/>
		<IconSvgGift
			:color="color"
			v-else-if="type === 'Gift'"
		/>
		<IconSvgGlobe
			:color="color"
			v-else-if="type === 'Globe'"
		/>
		<IconSvgGraduate
			:color="color"
			v-else-if="type === 'Graduate'"
		/>
		<IconSvgGraph
			:color="color"
			v-else-if="type === 'Graph'"
		/>
		<IconSvgHeadSet
			:color="color"
			v-else-if="type === 'Headset'"
		/>
		<IconSvgJobs
			:color="color"
			v-else-if="type === 'Jobs'"
		/>
		<IconSvgMegaphone
			:color="color"
			v-else-if="type === 'Megaphone'"
		/>
		<IconSvgMemberDirectory
			:color="color"
			v-else-if="type === 'Member_directory'"
		/>
		<IconSvgNotifications
			:color="color"
			v-else-if="type === 'Notifications'"
		/>
		<IconSvgPartners
			:color="color"
			v-else-if="type === 'Partners'"
		/>
		<IconSvgScale
			:color="color"
			v-else-if="type === 'Scale'"
		/>
		<IconSvgSchool
			:color="color"
			v-else-if="type === 'School'"
		/>
		<IconSvgFolder
			:color="color || styles.navigation_bar_tint"
			v-else
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

import IconSvgBank from '@/components/Resource/Icons/IconSvgBank.vue'
import IconSvgBook from '@/components/Resource/Icons/IconSvgBook.vue'
import IconSvgBookClosed from '@/components/Resource/Icons/IconSvgBookClosed.vue'
import IconSvgBulb from '@/components/Resource/Icons/IconSvgBulb.vue'
import IconSvgCalculator from '@/components/Resource/Icons/IconSvgCalculator.vue'
import IconSvgCategories from '@/components/Resource/Icons/IconSvgCategories.vue'
import IconSvgBuy from '@/components/Resource/Icons/IconSvgBuy.vue'
import IconSvgPin from '@/components/Resource/Icons/IconSvgPin.vue'
import IconSvgCertificat from '@/components/Resource/Icons/IconSvgCertificat.vue'
import IconSvgChair from '@/components/Resource/Icons/IconSvgChair.vue'
import IconSvgClock from '@/components/Resource/Icons/IconSvgClock.vue'
import IconSvgCommunity from '@/components/Resource/Icons/IconSvgCommunity.vue'
import IconSvgCompanyDirectory from '@/components/Resource/Icons/IconSvgCompanyDirectory.vue'
import IconSvgFolder from '@/components/Resource/Icons/IconSvgFolder.vue'
import IconSvgGift from '@/components/Resource/Icons/IconSvgGift.vue'
import IconSvgGlobe from '@/components/Resource/Icons/IconSvgGlobe.vue'
import IconSvgGraduate from '@/components/Resource/Icons/IconSvgGraduate.vue'
import IconSvgGraph from '@/components/Resource/Icons/IconSvgGraph.vue'
import IconSvgHeadSet from '@/components/Resource/Icons/IconSvgHeadSet.vue'
import IconSvgJobs from '@/components/Resource/Icons/IconSvgJobs.vue'
import IconSvgMegaphone from '@/components/Resource/Icons/IconSvgMegaphone.vue'
import IconSvgMemberDirectory from '@/components/Resource/Icons/IconSvgMemberDirectory.vue'
import IconSvgNotifications from '@/components/Resource/Icons/IconSvgNotifications.vue'
import IconSvgPartners from '@/components/Resource/Icons/IconSvgPartners.vue'
import IconSvgScale from '@/components/Resource/Icons/IconSvgScale.vue'
import IconSvgSchool from '@/components/Resource/Icons/IconSvgSchool.vue'

export default {
	name: 'ResourceIcon',
	components: {
		IconSvgBank,
		IconSvgBook,
		IconSvgBookClosed,
		IconSvgBulb,
		IconSvgCalculator,
		IconSvgCategories,
		IconSvgBuy,
		IconSvgPin,
		IconSvgCertificat,
		IconSvgChair,
		IconSvgClock,
		IconSvgCommunity,
		IconSvgCompanyDirectory,
		IconSvgFolder,
		IconSvgGift,
		IconSvgGlobe,
		IconSvgGraduate,
		IconSvgGraph,
		IconSvgHeadSet,
		IconSvgJobs,
		IconSvgMegaphone,
		IconSvgMemberDirectory,
		IconSvgNotifications,
		IconSvgPartners,
		IconSvgScale,
		IconSvgSchool
	},
	props: {
		type: {
			type: String,
			default: ''
		},
		color: {
			type: String,
			default: '#000000',
		},
	},
	computed: {
		...mapGetters('settings', ['styles']),
	}
};
</script>

<style scoped>

</style>